import "./standardMaterial.decalMap";
import "./PBR/pbrMaterial.decalMap";
import "../Meshes/abstractMesh.decalMap";
